<template>
	<div class="div1">
		<el-backtop target=".div1"></el-backtop>
		<!-- 头部 -->
		<Head :data="searchList"></Head>
		<!-- 中部内容 -->
		<div style="background: #F6F5F7;">
			<!-- 导航 -->
			<div class="navigation">
				<div class="navList">
					<div class="classify active" style="min-width: 228px;position: relative;"  v-if="active==0">
						全部分类
						<div class="dropdown1" style="position: absolute;top: 40px;">
							<div style="width: 228px;display: inline-block;display: flex;flex-wrap: wrap;">
								<div style="width: 50%;text-align: center;padding: 14px 0;line-height: 18px;"
									v-for="(item,index) in classifyList" :key="index"
									:command="'/productList?type='+item.id+'&title='+item.name" @click="switchover(item)">{{item.name}}
								</div>
							</div>
						</div>
					</div>
					<div class="classify active" style="min-width: 228px;position: relative;"  v-else >
						全部分类
						<div class="dropdown" style="position: absolute;top: 40px;">
							<div style="width: 228px;display: inline-block;display: flex;flex-wrap: wrap;">
								<div style="width: 50%;text-align: center;padding: 14px 0;line-height: 18px;"
									v-for="(item,index) in classifyList" :key="index"
									:command="'/productList?type='+item.id+'&title='+item.name" @click="switchover(item)">{{item.name}}
								</div>
							</div>
						</div>

					</div>
					<div v-for="(item,index) in navList" :key="index" :class="index!=0 && index==active?'active':''" class="navName"
						@click="onNavigation(index,item)" :title="item.title">
						{{ item.title }}
					</div>
				</div>
			</div>
			<!-- 第一部分 -->
			<div class="ones tong" v-if="active==0">

				<!-- 轮播图 -->
				<div class="ist is_conts">
					<el-carousel height="465px">
						<el-carousel-item v-for="(item,index) in bannerList" :key="index">
							<img :src="item.imgUrl+'?x-oss-process=image/resize,h_465'" class="bannerName" />
						</el-carousel-item>
					</el-carousel>
				</div>
			</div>

			<div class="tong" v-if="activityList.length&&active==0" v-loading="tableDataLoading1" v-for="itemData in activityList">
				<div style="display: flex;align-items: center;margin: 10px 0;">
					<img src="../../assets/index/new.png" style="width: 29px;height: 34px;" v-if="itemData.title=='每日新品'">
					<img src="../../assets/index/time.png" style="width: 30px;height: 34px;" v-if="itemData.title=='每日必抢'">
					<img src="../../assets/index/new.png" style="width: 29px;height: 34px;" v-if="itemData.title=='巨划算'">
					<div style="font-weight: bold;color: #333233;font-size: 18px;margin-left: 10px;">{{itemData.title}}</div>
				</div>
				<div style="background-color: #FFFFFF;display: flex;flex-wrap: wrap;" v-loading="tableDataLoading1">
					<div style="width: 238px;border: 1px solid #f2f2f2;cursor:pointer;" v-for="(item,index) in itemData.datas"
						v-if="index<10" @click="goDet(item)">
						<div class="padding-lg" style="border-bottom: 1px solid #f2f2f2;padding:14px">
							<img :src="item.coverImg+'?x-oss-process=image/resize,h_210,w_210'" style="width: 210px;height: 210px;" :title="item.title">
						</div>
						<div class="padding-sm">
							<div class="text-black" :title="item.title">
								{{item.title}}
							</div>
							<div style="display: flex;align-items: center;">
								<div style="font-size: 22px;color: #FF2D55;">¥{{ item.price }}</div>
								<div class="text-gray"
									style="font-size: 13px;font-style:italic;margin-left: 5px;text-decoration:line-through">
									批发价:¥{{item.originalPrice}}</div>
							</div>
							<div class="text-gray text-df" style="overflow: hidden;white-space: nowrap;
							text-overflow: ellipsis;display: flex;justify-content:space-between;">
								<span style="text-align: left;">
									<span v-if="item.styleId==1">国内贸易</span>
									<span v-if="item.styleId==2">完税进口</span>
									<span v-if="item.styleId==3">香港直邮</span>
									<span v-if="item.styleId==4">保税区直供</span>
									<span v-if="item.styleId==5">海外直邮</span>
								</span>
								<span style="text-align: right;">月进货门店 {{item.sales}}</span>
							</div>
						</div>
					</div>
				</div>
			</div>

			<!-- 分类列表 -->
			<div class="tong" v-for="(item,index) in classifyList" :key="index" v-if="active==0" v-loading="tableDataLoading">
				<div class="flex">
					<div style="width: 17%">
						<div class="flex align-center margin-tb-sm">
							<!-- <div style="width: 6px;background: #DD4545;border-radius: 3px;"></div> -->
							<div class="margin-left-xs text-xl text-bold" style="color: #333233;">
								<span style="padding-left: 6px;border-left: 6px solid #DD4545;border-radius:3px"></span>
								{{item.name}}
							</div>
						</div>
					</div>
					<div class="text-df flex align-center margin-tb-sm" >热门分类：</div>
					<div class="text-df flex align-center margin-tb-sm" style="color: #606266;margin-right:10px;width:72%">
						<span>
							<span v-for="(ite,ind) in item.children" class="fonts"
							 style="cursor: pointer;overflow:hidden; height:12px;"
							 @click="switchCate(item.id, ite.id, item)">{{ite.name}}
								<span v-if="ind<item.children.length" style="margin:0 4px"> |</span>
							</span>
						</span>
					</div>
					<div class="flex-sub text-right text-gray text-df margin-tb-sm"
						style="cursor: pointer;" @click="switchover(item)">
						更多 <i class="el-icon-arrow-right"></i>
					</div>
				</div>

				<div class="flex justify-between" style="width: 1200px;">
					<div style="height: calc(100%-24px);position: relative;">
						<img :src="item.img" style="width: 200px;height: 100%;">
					</div>
					<div class="bg-white flex flex-wrap" style="width: 1000px;" v-if="goodsList[index]">
						<div style="width: 198px;border: 1px solid #f2f2f2;height: 322px;cursor:pointer;"
							v-for="(ita,ine) in goodsList[index]" :key="ine" @click="goDet(ita)">
							<img :src="ita.coverImg+'?x-oss-process=image/resize,h_200,w_198'" style="width: 198px;height: 200px;" :title="ita.title">
							<div style="padding: 14px;">
								<div class="text-black" :title="ita.title">
									{{ita.title}}
								</div>
								<div style="display: flex;align-items: center;">
									<div class="text-xxl" style="color: #FF2D55;">
										¥{{ita.price}}</div>
									<div class="text-gray text-sm margin-left-xs" style="text-decoration:line-through;font-style:italic">
										批发价:¥{{ita.originalPrice}}</div>
								</div>
								<div class="text-gray text-df">月进货门店 {{ita.sales}}</div>
							</div>
						</div>

						<el-empty style='width: 100%;' v-if="goodsList[index].length==0" description="暂无数据"></el-empty>
					</div>
					<div v-else class="bg-white flex flex-wrap" style="width: 1000px;">
						<el-empty style='width: 100%;' description="暂无数据"></el-empty>
					</div>
				</div>
			</div>

			<div class="tong three" v-if="active!=0">
				<div class="table_main">
					<table>
						<tbody>
							<tr>
								<th class="left-th">排序</th>
								<th class="border-bt right-th">
									<div v-for="(item,index) in classList1" :key="index"
										:class="index==active3?'active2':''" class="className"
										@click="classOn1(index,item)" :title="item.title">{{ item.title }}</div>
								</th>
							</tr>
						</tbody>
					</table>
				</div>
			</div>

			<div class="tong three" v-if="dataList.content.length!=0&&active!=0" v-loading="tableDataLoading1">
				<goodsItem :title="title" :data="dataList.content"></goodsItem>
			</div>

			<div class="tong three" v-if="dataList.content.length!=0&&active!=0">
				<Pagination :total="dataList.totalElements" :page="page" :limit="size" @pagination="paginateChange"></Pagination>
			</div>
			<div class="emptyWrap" v-if="dataList.content.length==0 && active!=0">
				<img src="../../../static/images/empty.png">
				<div style="">暂无数据</div>
			</div>

		</div>
		<div class="padding-sm bg-white" style="position: fixed;top: 240px;right: 0px;z-index: 10;border-radius: 10px;">
			<div class="text-center wechat">
				<img src="../../assets/index/wechat.png" style="width: 38px;height: 38px;">
				<div>微信</div>
				<img src="../../assets/index/wxkefu.png" class="image" style="">
			</div>
			<div class="text-center margin-top-sm">
				<img src="../../assets/index/customer.png" style="width: 38px;height: 38px;" onclick="qimoChatClick()">
				<div>客服</div>
				<div class="imageText">在线咨询客服</div>
			</div>
			<div class="text-center margin-top-sm">
				<img src="../../assets/index/phone.png" style="width: 38px;height: 38px;">
				<div>电话</div>
				<div class="imageText">4006630038</div>
			</div>
			<div class="text-center margin-top-sm">
				<img src="../../assets/index/download.png" style="width: 38px;height: 38px;" @click="skipTo">
				<div>下载</div>
				<div class="imageText">下载安装到电脑桌面</div>
			</div>
		</div>

		<!-- 底部 -->
		<Foots style="margin-top: 40px;"></Foots>
	</div>
</template>

<script>
	import Head from '@/components/head.vue'
	import Foots from '@/components/foots.vue'
	import goodsItem from "../../components/goods-item";
	import empty from '@/components/empty.vue'
	import { Loading } from "element-ui"
	import Pagination from '../../components/page.vue'
	export default {
		components: {
			Head,
			Foots,
			goodsItem,
			empty,
			Pagination
		},
		data() {
			return {
				page: 1,
				size: 50,
				sort: 'create_at',
				searchList: ['粽子', '防晒霜', '洗衣液', '蚊香液', '抽纸', '零食'],
				navList: [],
				active: 0,
				active1: 0,
				active2: 0,
				active3: 0,
				bannerList: [],
				goodsList: [],
				activityList: [],
				dataList: {
					content: []
				},
				classList1: [{
					title: '综合',
					sort: 'create_at',
					type: 'activity'
				}, {
					title: '销量',
					sort: 'sales',
					type: 'activity'
				}, {
					title: '超低价',
					sort: 'price',
					type: 'activity'
				}],
				userId: '',
				type: '',
				classifyList: [],
				gonggaoList: [],
				tableDataLoading: false,
				tableDataLoading1:false,
				activityId:'',
				styleId:'',
				title: '',
				classifyLength: 0
			}
		},
		created() {
			this.userId = this.$cookie.get('userId')
			this.classifyList = JSON.parse(window.sessionStorage.getItem("classify"))

			if(!this.classifyList){
				this.getLeftList()
			} else {
				this.classifyLength = this.classifyList.length
				this.getTypeList()
			}
		},
		mounted() {
			this.userId = this.$cookie.get('userId')

			var qimoClientId = {
			    userId: this.userId,
				nickName: this.$cookie.get('mobile'),
			    customField: {
			        "手机号": this.$cookie.get('mobile')
			    },
			    refreshUnreopen: true,
			};

			this.bannerSelect()
			this.homeSelectJ()
			this.getSearchList()

			window.addEventListener('scroll', this.handleScroll, true)
		},
		/* destroyed() {
			window.removeEventListener('scroll', this.btn_pos)
		}, */
		methods: {
			paginateChange(res){
				this.page = res.page;
				this.size = res.limit;
				this.getDataList()
				// 请求表格数据
			},
			handleScroll() {
				var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
				// console.log('滚动高度', scrollTop)
			},
			goDet(e) {
				window.open('#/goodsDet?id=' + e.id, '_blank');
			},
			getSearchList() {
				this.$http({
					url: this.$http.adornUrl('/common/type/285'), //热词
					method: 'get',
				}).then(({
					data
				}) => {
					this.searchList = data.data.value.split(',')
				})
			},
			/* getHomeGongGao() {
				this.$http({
					url: this.$http.adornUrl('/message/page/1/0/5'),
					method: 'get',
				}).then(({
					data
				}) => {
					this.gonggaoList = data.data
				})
			}, */
			//轮播图跳转
			bannerSkip(e) {
				window.location.href = e.linkUrl
			},
			onNavigation(index, item) {
				this.active = index
				this.active3 = 0 //重置排序
				this.page = 1

				if(item.type == 'index') {
					this.getTypeList()
				}else if (item.type == 'style') {
					this.type = 'style'
					this.styleId = item.id
					this.activityId = ''
					this.getDataList()
				} else {
					this.type = 'activity'
					this.activityId = item.id
					this.styleId = ''
					this.getDataList()
				}
			},
			getDataList() {
				this.tableDataLoading1 = true
				this.$http({
					url: this.$http.adornUrl('/goods/goodsList'),
					method: 'get',
					params: this.$http.adornParams({
						'page': this.page - 1,
						'size': this.size,
						'activityId': this.activityId,
						'styleId': this.styleId,
						'sort': this.sort,
						'userId': this.userId,
					})
				}).then(({
					data
				}) => {
					this.tableDataLoading1 = false
					if(data.status==0) {
						this.dataList = data.data
					}
				})
			},

			classOn1(index, item) {
				this.active3 = index
				this.sort = item.sort

				if(this.type == 'activity') {
					this.getDataList()
				} else {
					this.getDataList()
				}
			},
			// 获取轮播图
			bannerSelect() {
				this.$http({
					url: this.$http.adornUrl('/advert/list'),
					method: 'get',
					params: this.$http.adornParams({
						type: 2
					})
				}).then(({
					data
				}) => {
					this.bannerList = data.data
				})
			},
			getLeftList() {
				this.$http({
					url: this.$http.adornUrl('/goodsType/findList'),
					method: 'get',
					params: this.$http.adornParams({})
				}).then(({
					data
				}) => {
					this.classifyList = [];
					if (data.status === 0) {
						this.classifyList = data.data
						this.classifyLength = this.classifyList.length
						window.sessionStorage.setItem("classify", JSON.stringify(this.classifyList))
						this.getTypeList()
					}
				})
			},
			getTypeList() {
				this.tableDataLoading = true

				this.$http({
					url: this.$http.adornUrl('/goodsType/userGoodsTypeList'),
					method: 'get',
					params: this.$http.adornParams({
						sort: 'create_at',
						userId: this.userId
					})
				}).then(({
					data
				}) => {
					if (data.status === 0) {
						this.goodsList = data.data
					}
					this.tableDataLoading = false
				})
			},
			switchover(item) {
				var children = JSON.stringify(item.children)
				window.sessionStorage.setItem('children', children)
				window.open('/#/productList?type=' + item.id, '_blank');
			},
			switchCate(typeId, cateId, item) {
				var children = JSON.stringify(item.children)
				window.sessionStorage.setItem('children', children)
				window.open('/#/productList?cate=' + cateId, '_blank');
			},
			// 获取集合分类数据列表
			homeSelectJ() {
				this.tableDataLoading = true
				this.$http({
					url: this.$http.adornUrl(`/activity/state/8`),
					method: 'get',
					params: this.$http.adornParams({})
				}).then(({
					data
				}) => {
					this.tableDataLoading = false
					let arr = [{
							title: '首页',
							type: 'index'
						},{
							title: '国内贸易',
							type: 'style',
							id: 1
						},
						{
							title: '完税进口',
							type: 'style',
							id: 2
						},
						{
							title: '香港直邮',
							type: 'style',
							id: 3
						},
						{
							title: '保税区直供',
							type: 'style',
							id: 4
						},
						{
							title: '海外直邮',
							type: 'style',
							id: 5
						}
					]

					let activityArr = []

					for(var i in data.data){
						if(data.data[i].type){
							data.data[i].typeArr = data.data[i].type.split(',')
							for(var j in data.data[i].typeArr){
								if(data.data[i].typeArr[j]=='13'){
									arr.push(data.data[i])
									activityArr.push(data.data[i])
								}
							}
						}
					}
					for(var i=0;i<activityArr.length;i++) {
						this.tableDataLoading1 = true
						let title = activityArr[i].title
						this.$http({
							url: this.$http.adornUrl('/goods/goodsList'),
							method: 'get',
							params: this.$http.adornParams({
								page: this.page - 1,
								size: 10,
								activityId: activityArr[i].id,
								sort: 'create_at',
								userId: this.userId
							})
						}).then(({
							data
						}) => {
							if (data.status === 0) {
								this.tableDataLoading1 = false
								this.activityList.push({
									"title": title,
									"datas": data.data.content
								})
							}
						})
					}

					this.navList = arr
				})
			},
			// 返回顶部
			toTop() {
				document.documentElement.scrollTop = 0;
			},
			skipTo() {
				window.open('#/empty', '_blank');
			}
		}
	}
</script>

<style scoped>
	.div1 {
		height: 100vh;
		overflow-x: hidden;
	}

	/* 导航 */
	.navigation {
		height: 40px;
		line-height: 40px;
	}

	.navList {
		width: 1200px;
		margin: 0 auto;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.navName {
		display: inline-block;
		width: 12%;
		height: 40px;
		text-align: center;
		cursor: pointer;
	}

	.classify {
		display: inline-block;
		width: 12%;
		height: 40px;
		text-align: center;
		cursor: pointer;
		/* color: #fff;
		background: #D13030; */
	}

	.classify:hover {
		color: #fff;
		background: #D13030;
	}
	.classify:hover .dropdown {
		display: block;
	}

	.active {
		background: #D13030;
		color: #fff;
	}

	.dropdown {
		display: none;
		z-index: 10;
		width: 228px;
		min-height: 435px;
		color: #FFF;
		background: #DD4545;
	}
	.dropdown1 {
		z-index: 10;
		width: 228px;
		min-height: 435px;
		color: #FFF;
		background: #DD4545;
	}

	/* 第一部分 */
	.tong {
		width: 1200px;
		margin: 0 auto;
		margin-top: 20px;
	}

	.ones {
		width: 100%;
		height: 450px;
	}

	.ist {
		display: inline-block;
		height: 440px;
		box-sizing: border-box;
	}

	.is_left {
		width: 20%;
		overflow-y: auto;
		margin-right: 1.5%;
		line-height: 40px;
		padding: 20px;
		color: #333333;
		font-size: 14px;
		background: #fff;
		border-radius: 4px;
		float: left;
	}

	.nameCl:hover {
		color: #FF2D55;
		cursor: pointer;
	}

	.is_conts {
		width: 100%;
		height: 400px;
	}

	.bannerName {
		width: 100%;
		height: 100%;
	}

	.is_right {
		width: 25%;
		color: #333333;
		font-size: 14px;
		background: #fff;
		border-radius: 4px;
		box-sizing: border-box;
		height: 440px;
		float: right;
	}

	.rightTop {
		padding: 20px;
	}

	.imgTop {
		width: 50px;
		height: 50px;
		border-radius: 50%;
		float: left;
	}

	.topR {
		margin-left: 60px;
		line-height: 25px;
	}

	.topL {
		margin-left: 60px;
		line-height: 50px;
		height: 50px;
	}

	.topL>div:hover {
		cursor: pointer;
	}

	.Rname {
		font-size: 20px;
	}

	.Ryaoqingma {
		font-size: 14px;
	}

	.rightVip {
		margin: 0 20px 15px;
		padding: 0;
		height: 40px;
		border-radius: 5px;
		background: #FF2D55;
		color: #fff;
	}

	.rightVip div {
		display: inline-block;
	}

	.rightNoVip {
		margin: 0 20px 15px;
		height: 40px;
		border-radius: 5px;
		background: #FF2D55;
		color: #fff;
		display: flex;
		justify-content: space-between;
		align-items: center;
		line-height: 40px;
		padding: 0 20px;
		font-size: 16px;
	}

	.rightBtn {
		width: 80px;
		height: 27px;
		text-align: center;
		font-size: 12px;
		color: #333;
		border-radius: 16px;
		z-index: 1;
		background: #fde3de;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.vipName {
		line-height: 40px;
		padding-left: 15px;
		font-size: 18px;
		font-weight: 600;
	}

	.vipKthy {
		background: #fff;
		font-size: 12px;
		color: #FF2D55;
		height: 20px;
		line-height: 20px;
		margin-left: 36%;
		padding: 0 6px;
		border-radius: 20px;
	}

	.vipKthy:hover {
		cursor: pointer;
	}

	.Rclass {
		padding: 0 20px 15px;
		border-bottom: 1px solid #F2F2F2;
		box-sizing: border-box;
		margin-top: 30px;
	}

	.classList {
		display: inline-block;
		width: 23%;
		text-align: center;
	}

	.RlistNum {
		font-size: 24px;
		font-weight: 600;
	}

	.RlistName {
		font-size: 14px;
	}

	.Rbottom {
		padding: 15px 20px;

	}

	.bottomTitle {
		font-size: 20px;
		font-weight: 600;
		margin-bottom: 15px;
	}

	.bottomS {
		font-size: 12px;
		margin: 20px 0px;
	}

	.bottomList {
		padding: 15px 0;
	}

	.listI {
		display: inline-block;
		width: 32%;
		text-align: center;
	}

	.bottomImg {
		width: 34px;
	}

	/* 第二部分 */
	.seconds {
		background: url(../../assets/index/bg.png) no-repeat;
		background-size: 100% 100%;
		box-sizing: border-box;
		height: 275px;
		border-radius: 5px;
	}

	.secondsleft {
		width: 15%;
		float: left;
		color: #fff;
		font-size: 18px;
		padding: 20px;
		box-sizing: border-box;
	}

	.secondsleft_title {
		font-size: 30px;
		font-weight: 600;
		line-height: 40px;
	}

	.secondsleft_dixy {
		height: 177px;
	}

	.chakan {
		cursor: pointer;
	}

	.secondsRight {
		margin-left: 16%;
		border: none;
		border-radius: 6px;
		background: #fff;
		border: 1px solid #FF2D55;
		box-sizing: border-box;
	}

	.secondsRight_list {
		display: inline-block;
		width: 20%;
		box-sizing: border-box;
		padding: 20px;
		font-size: 18px;

	}

	.secondsRight_title {
		line-height: 30px;
		color: #333;
		font-weight: 600;
		text-align: center;
	}

	.secondsRight_sm {
		font-size: 13px;
		color: #999;
		margin-bottom: 20px;
		text-align: center;
	}

	.secondsRight_img {
		width: 100%;
		height: 161px;
	}

	/* 第三部分 */
	.navList2 {
		width: 100%;
		height: 40px;
		line-height: 40px;
		font-size: 18px;
		color: #333;
		background: #fff;
		border-radius: 2px;
	}

	.navName1 {
		display: inline-block;
		width: 16.66%;
		text-align: center;
		cursor: pointer;
		border-radius: 4px;
	}

	.active1 {
		background: #FF2D55;
		color: #fff;
	}

	/* 筛选表格 */
	.table_main table {
		width: 100%;
	}

	.table_main {
		border: 1px solid #e8e8e8;

	}

	table tr {
		background: #fff;
	}

	table tr th {
		padding: 16px 24px;
	}

	table tr td {
		padding: 16px 24px;
		border-bottom: 1px solid #e8e8e8;
	}

	table th {
		color: rgba(0, 0, 0, .85);
		font-weight: 400;
		font-size: 14px;
		line-height: 1.5;
	}

	.border-rt {
		border-right: none !important;
	}

	.border-bt {
		border-bottom: none !important;
	}

	.left-th {
		color: #333;
		width: 50px;
		line-height: 50px;
	}

	.right-th {
		text-align: left;
		padding-left: 30px;
	}

	.className {
		display: inline-block;
		background-color: #fff;
		font-size: 14px;
		color: #333;
		margin: 10px 5px;
		padding: 0 20px;
		text-align: center;
		cursor: pointer;
	}

	.active2 {
		background: #FF2D55;
		color: #fff;
		border-radius: 4px;
	}

	.emptyWrap {
		width: 100%;
		text-align: center;
		margin: 80px 0;
	}

	.emptyWrap>div {
		font-size: 24px;
		font-weight: 700;
		color: #999999;
	}
	.text-center{
		position: relative;
		cursor: pointer;
	}


	.imageText {
		position: absolute;
		top: 0px;
		right: 60px;
		width: 150px;
		background: #fff;
		height: 60px;
		line-height: 60px;
		display: none;
	}
	.margin-top-sm:hover .imageText{
		display: block;
	}

	.image {
		position: absolute;
		top: 0px;
		right: 60px;
		width: 150px;
		height: 150px;
		display: none;
	}
	.wechat:hover .image {
		display: block;
	}

	.fonts {
		color: #333233;
	}
	.fonts:hover{
		color: #999;
	}
	.text-black {
		overflow: hidden;
		font-size: 16px;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
	}
</style>



// WEBPACK FOOTER //
// src/views/homePage/index.vue